import React, { useState, useEffect } from 'react'
import { getLoaneligibilityByUserId } from '../../AdminActionCreator.component'
import Loader from '../../../../presentationals/Loader/Loader.component'

export default function LoanDetails({ userDetails }) {
    const [loader, setLoader] = useState(false)
    const [data, setData] = useState({})

    useEffect(() => {
        getLoaneligibilityByUserIdFn(userDetails)
    }, [])

    const getLoaneligibilityByUserIdFn = (data) => {
        setLoader(true)
        getLoaneligibilityByUserId(data?.userId,0, callback => {
            console.log("callback", callback)
            if (callback?.message == "success" && callback?.status == 200) {
                setData(callback?.data)
            } else {
                setData({})
            }
            setLoader(false)
        })
    }
    return (
        <>
            {
                loader ?
                    <Loader />
                    : ''}

            <div className="container-fluid" style={{marginTop:'80px'}}>
                <div className="row">
                    <div className="col-sm-6 col-xs-12">
                        {
                            data && Object.keys(data)?.length > 0 ?
                                <div className="Tables">
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th>Particular</th>
                                                <th>Value</th>
                                              
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>Predicted Income</td>
                                                <td>{data?.predictedIncome ?? ""}</td>
                                                
                                            </tr>
                                            <tr>
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>Net Disposable Income</td>
                                                <td>{data?.netDisposableIncome ?? ""}</td>
                                              
                                            </tr>
                                            <tr>
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>Calculated Loan Eligible Amount</td>
                                                <td>{data?.calculatedLoanEligibleAmount ?? ""}</td>
                                              
                                            </tr>
                                            <tr>
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>EMI From Bureau</td>
                                                <td>{data?.emiFromBureau ?? ""}</td>
                                               
                                            </tr>
                                            <tr>
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>Interest Rate</td>
                                                <td>{data?.interestRate ?? ""}</td>
                                              
                                            </tr>
                                            <tr>
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>LTV</td>
                                                <td>{data?.ltv ?? ""}</td>
                                             
                                            </tr>
                                            <tr>
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>Adjusted Energy Consumption</td>
                                                <td>{data?.adjustedEnergyConsumption ?? ""}</td>
                                                
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                : ''}
                    </div>
                    <div className="col-sm-6 col-xs-12">
                        {
                            data && Object.keys(data)?.length > 0 ?
                                <div className="Tables">
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                              
                                                <th>Particular</th>
                                                <th>Value</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                             
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>Adjusted Range</td>
                                                <td>{data?.adjustedRange ?? ""}</td>
                                            </tr>
                                            <tr>
                                              
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>Tenure</td>
                                                <td>{data?.tenure ?? ""}</td>
                                            </tr>
                                            <tr>
                                               
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>EMI Amount</td>
                                                <td>{data?.emiAmount ?? ""}</td>
                                            </tr>
                                            <tr>
                                               
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>HouseHold Expense</td>
                                                <td>{data?.householdExpense ?? ""}</td>
                                            </tr>
                                            <tr>
                                               
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>Customer Type</td>
                                                <td>{data?.customerType ?? ""}</td>
                                            </tr>
                                            <tr>
                                                
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>Loan Amount</td>
                                                <td>{data?.loanAmount ?? ""}</td>
                                            </tr>
                                            <tr>
                                               
                                                <td style={{textAlign:'left',fontWeight:'700',width:'300px',paddingLeft:'15px'}}>FOIR</td>
                                                <td>{data?.foir ?? ""}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                : ''}
                    </div>
                </div>
            </div>
        </>
    )
}
